export default __webpack_public_path__ + "79cc740.png";